import { render, staticRenderFns } from "./ClaimTermModal.vue?vue&type=template&id=10a17e58&scoped=true&"
import script from "./ClaimTermModal.vue?vue&type=script&lang=js&"
export * from "./ClaimTermModal.vue?vue&type=script&lang=js&"
import style0 from "./ClaimTermModal.vue?vue&type=style&index=0&id=10a17e58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a17e58",
  null
  
)

export default component.exports